import scheduleMaintenance from './middleware/scheduleMaintenance'
import recoverAPI from './middleware/recoverAPI'
import ClientOffline from './../components/ClientOffline.vue'

export default [
    // Server Error
    {
        path: '/serverError',
        name: 'serverError',
        meta: {
            title: 'Server Error',
            middleware: [scheduleMaintenance, recoverAPI]
        },
        component: () => import('./../components/ServerError.vue')
    },

    // Server Encountered Error
    {
        path: '/serverEncounteredError',
        name: 'serverEncounteredError',
        meta: {
            title: 'Server Encountered Error',
            middleware: [scheduleMaintenance]
        },
        component: () => import('./../components/ServerEncounteredError.vue')
    },

    // Server Maintenance
    {
        path: '/serverMaintenance',
        name: 'serverMaintenance',
        meta: {
            title: 'Server Maintenance'
        },
        component: () => import('./../components/ServerMaintenance.vue')
    },

    // Client Offline
    {
        path: '/clientOffline',
        name: 'clientOffline',
        meta: {
            title: 'Client Offline'
        },
        component: ClientOffline
    },

    // Page Not Found Page
    {
        path: '/404',
        name: 'pageNotFound',
        meta: {
            title: 'Page Not Found'
        },
        component: () => import('./../components/PageNotFound.vue')
    },

    // All not declared paths will redirect to /404
    {
        path: '/:pathMatch(.*)*',
        name: 'unknownPage',
        meta: {
            title: 'Page Not Found'
        },
        component: () => {
            window.location.href = '/404'
        }
    }
]
